module.exports = __webpack_public_path__ + "static/img/logo25.956279f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo25.png
// module id = gFCa
// module chunks = 1